
import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";

import {
  UPDATE_EMAIL_CONTACT,
  UPDATE_EMAIL_CONTACT_START,
  UPDATE_EMAIL_CONTACT_SUCCESS,
  UPDATE_EMAIL_CONTACT_ERROR,
  UPDATE_EMAIL_CONTACT_FINALLY,
  GET_KC_USER,
  GET_KC_USER_START,
  GET_KC_USER_SUCCESS,
  GET_KC_USER_ERROR,
  GET_KC_USER_FINALLY,
  CHANGE_EMAIL_SSO,
  CHANGE_EMAIL_SSO_START,
  CHANGE_EMAIL_SSO_SUCCESS,
  CHANGE_EMAIL_SSO_ERROR,
  CHANGE_EMAIL_SSO_FINALLY,
  SET_EMAIL_MODAL_STATUS,
  SET_KC_USER,
  UPDATE_SUBSCRIBER,
  AUTH_KEYCLOAK_ERROR,
} from "../../redux/actions";

import { refreshTokenOttWeb } from '../../utils/refreshtoken';
import { getUserInfo } from "../../utils/tokenStorage";

function* UpdateEmailContactAction({ payload: { keycloak, id, newData } }) {
  yield put(UPDATE_EMAIL_CONTACT_START());
  let token;
  try {
    token = (yield call(refreshTokenOttWeb, keycloak)).token
  } catch (err) {
    yield put(AUTH_KEYCLOAK_ERROR({ error: err.message }))
    yield put(UPDATE_EMAIL_CONTACT_FINALLY());
    return
  }
  try {

    const headers = {
      headers: { 'authorization': `Bearer ${token}` },
      timeout: 10000
    }
    const data = yield call(
      axios.put,
      `${process.env.REACT_APP_SUBSCRIPTIONS_API_URL}subscribers/${id}`,
      newData,
      headers,
    );

    yield put(UPDATE_EMAIL_CONTACT_SUCCESS(data));
  } catch (error) {
    yield put(UPDATE_EMAIL_CONTACT_ERROR(error.message));
  } finally {
    yield put(UPDATE_EMAIL_CONTACT_FINALLY());
  }
}

function* GetKcUserAction({ payload: { keycloak, sub, confirmEmail = false } }) {
  yield put(GET_KC_USER_START());

  try {
    const token = (yield call(refreshTokenOttWeb, keycloak)).token
    const config = {
      headers: { authorization: `Bearer ${token}` },
      timeout: 10000,
    };

    const { data } = yield call(
      axios.get,
      `${process.env.REACT_APP_SUBSCRIPTIONS_API_URL}kc/users/${sub}`,
      config
    );
    yield put(GET_KC_USER_SUCCESS(data));
    if (confirmEmail) {
      if (data?.emailVerified && !data?.email?.includes('@megago.cl')) {
        yield call(getUserInfo, keycloak);
        yield put(SET_EMAIL_MODAL_STATUS("ready_to_pay"));
      } else {
        yield put(SET_EMAIL_MODAL_STATUS("waiting_verification"));
      }
    }

  } catch (error) {
    yield put(GET_KC_USER_ERROR((error)));
    if (confirmEmail) yield put(SET_EMAIL_MODAL_STATUS("waiting_verification"));
  } finally {
    yield put(GET_KC_USER_FINALLY());
  }
}

function* changeEmailSsoSaga({ payload: { keycloak, sub, email } }) {
  yield put(CHANGE_EMAIL_SSO_START());

  try {
    const token = (yield call(refreshTokenOttWeb, keycloak)).token
    // const isTokenUpdated = yield call(keycloak.updateToken, 5);
    // token = isTokenUpdated ? keycloak.token : token;

    const headers = {
      headers: { 'authorization': `Bearer ${token}` },
      timeout: 10000
    }

    const body = {
      email
    };
    const { status, data } = yield call(
      axios.put,
      `${process.env.REACT_APP_SUBSCRIPTIONS_API_URL}kc/users/${sub}`,
      body,
      headers
    );

    if (status === 200 && data?.exists === false && data?.hasSubscription === false) {
      yield put(CHANGE_EMAIL_SSO_SUCCESS());
      yield put(SET_EMAIL_MODAL_STATUS("waiting_verification"));
    } else if (status === 200 && data) {
      yield put(SET_KC_USER(data));
      yield put(SET_EMAIL_MODAL_STATUS("server_message"));
      yield put(UPDATE_SUBSCRIBER({email}))
    }
  } catch (error) {
    if (error?.response?.status === 422) {
      yield put(SET_KC_USER(error?.response?.data));
      yield put(SET_EMAIL_MODAL_STATUS("server_message"));
      yield put(UPDATE_SUBSCRIBER({contact_email:email}))
    } else {
      yield put(CHANGE_EMAIL_SSO_ERROR(error));
    }
  } finally {
    yield put(CHANGE_EMAIL_SSO_FINALLY());
  }
}

export default function* SubscriberActionsWatcher() {
  yield takeLatest(UPDATE_EMAIL_CONTACT, UpdateEmailContactAction);
  yield takeLatest(GET_KC_USER, GetKcUserAction);
  yield takeLatest(CHANGE_EMAIL_SSO, changeEmailSsoSaga);
}